import React, { useMemo } from 'react'
import { Skeleton, Box } from '@mui/material'
import { Button, Col, Row } from 'react-bootstrap'

function getRandomWidth() {
  // Generate a random width between 20% and 40%
  return `${20 + Math.random() * 20}%`
}

function getRandomFieldCount() {
  // Generate a random number of fields per row (1 to 3 fields)
  return Math.floor(Math.random() * 4) + 1
}

const FormLoading = ({ height,title='Loading / กำลังโหลดข้อมูล...' }) => {
  const loadingRows = useMemo(() => {
    return Array.from({ length: 10 }).map(() =>
      Array.from({ length: getRandomFieldCount() }).map(() => getRandomWidth())
    )
  }, [])

  const FormFieldLoading = () => {
    return (
      <Box position="relative">
        {/* Header Skeleton */}
        <Skeleton variant="rectangular" width="100%" height={40} />

        {/* Body Skeleton with Random Widths and Field Counts */}
        <Box p={2}>
          {loadingRows.map((fields, rowIndex) => (
            <Box
              key={rowIndex}
              display="flex"
              justifyContent="flex-start"
              mb={1}
            >
              {fields.map(
                (width, fieldIndex) => (
                  <Skeleton
                    key={fieldIndex}
                    variant="text"
                    width={width}
                    height={50}
                    style={{ marginRight: 8 }}
                  />
                )
              )}
            </Box>
          ))}
        </Box>

        {/* Footer Skeleton */}
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Skeleton
            variant="rectangular"
            width={100}
            height={40}
            style={{ marginRight: 8 }}
          />
          <Skeleton variant="rectangular" width={100} height={40} />
        </Box>

        {/* Overlay Loading Text */}
        <Box
          position="absolute"
          top="50%"
          left="50%"
          style={{ transform: 'translate(-50%, -50%)' }}
          zIndex="tooltip"
        >
          <button
            type="button"
            disabled
            className="btn btn-theme btn-block"
            style={{ visibility: 'visible', fontSize: '18px' }}
          >
            <span
              className="spinner-border spinner-border-sm mr-1"
              role="status"
            />
            {title}
          </button>
        </Box>
      </Box>
    )
  }

  const BoxLoadingText = () => {
    return (
      <div>
        <Col sm="12" lg={12}>
          <Box className="my-2" sx={{ width: '100%' }}>
            <Skeleton variant="rectangular" width="100%">
              <div style={{ paddingTop: `${height}px` }} />
              <button
                type="button"
                disabled
                className="btn btn-theme btn-block"
                style={{ visibility: 'visible' }}
              >
                <span
                  className="spinner-border spinner-border-sm mr-1"
                  role="status"
                />
                Loading / กำลังโหลดข้อมูล...
              </button>
              <div style={{ paddingTop: `${height}px` }} />
            </Skeleton>
          </Box>
        </Col>
      </div>
    )
  }
  if (height) {
    return <BoxLoadingText />
  }
  return <FormFieldLoading />
}

export default FormLoading
